import {AfterViewInit, Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {SimpleFileUploaderComponent} from './simple-file-uploader.component';

@Component({
  selector: 'app-simple-file-uploader-input-component',
  template: `
    <app-simple-file-uploader class="uploader" #fileUploader [allowedExtensions]="allowedExtensions">
      <div style="grid-area: area">
        <img style="object-fit: cover;"
             [style.height]="height + 'px'"
             [style.width]="width"
             [style.background]="imageBackgroundColor"
             [src]="value"/>
        <button mat-icon-button color="primary" (click)="fileUploader.openSelectFile()"><mat-icon>edit</mat-icon></button>
      </div>
      <div class="uploading-overlay" *ngIf="fileUploader.filesStatus?.length">
        <div class="uploading-video-data" *ngFor="let upload of fileUploader.filesStatus">
          <mat-progress-bar style="grid-area: progress; margin: auto;"
                            color="accent"
                            *ngIf="upload.progress"
                            [mode]="'buffer'"
                            [value]="upload.status == 1 ? null : upload.progress" >
          </mat-progress-bar>
<!--          <div style="grid-area: status; margin-left: 8px;">{{upload.progress > 99 ? 'Procesando' : 'Subiendo'}}</div>-->

        </div>
      </div>
    </app-simple-file-uploader>
  `,
  styles: [
    `
        .uploader {
            display: grid;
            grid-template: "area";
        }
        .uploading-overlay {
            grid-area: area;
            padding: 8px;
            background: #d3d3d375;
            backdrop-filter: blur(4px);
            display: grid;
            align-content: center;
            justify-content: center;
        }

        .uploading-video-data {
            display: grid;
            grid-template:
        "title title"
        "status status"
        "progress cancel"
        / minmax(150px, 1fr) min-content;
            column-gap: 12px;
        }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PublicImageUploaderComponent),
      multi: true
    }
  ],
})

export class PublicImageUploaderComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() allowedExtensions = '.jpg,.jpeg,.png';
  @Input() imageBackgroundColor;

  @Input() isDisabled: boolean;

  @Input() height = 40;
  @Input() width = 'auto';

  @ViewChild('fileUploader') fileUploader: SimpleFileUploaderComponent;

  private _value: string;
  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
    this.propagateChange(this._value);
  }
  protected unregister$ = new Subject();
  protected propagateChange = (_) => {};
  protected onTouched = () => {};


  registerOnChange(fn: () => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.fileUploader.changes.subscribe(files => {
      this.value = files[0].url;
    });
  }

}
